export default "__VITE_PUBLIC_ASSET__aa6f4f2a__"